import { render, staticRenderFns } from "./handler.html?vue&type=template&id=37d1d89c&scoped=true&"
import script from "./Handler.vue?vue&type=script&lang=js&"
export * from "./Handler.vue?vue&type=script&lang=js&"
import style0 from "./Handler.vue?vue&type=style&index=0&id=37d1d89c&scoped=true&lang=css&"
import style1 from "./Handler.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d1d89c",
  null
  
)

export default component.exports